<div class="row form-row">
    <div class="col-sm-12">
        <h5 class="text-green mt-3">Inquiry ID: {{IqrNum}}</h5>
    </div>
</div>
<div class="form-row mt-2">
    <table class="table table-responsivetable-striped" aria-hidden="true">
        <thead>
            <tr>
                <th scope="col" style="width:10%;"><b>Type of File</b></th>
                <th scope="col"><b>Uploaded Document Name</b></th>
                <th scope="col"><b>Action</b></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td *ngIf="inquirydoc && inquirydoc.InquiryReceivedCopy!=''">
                    <img src="{{url+inquirydoc.InquiryReceivedCopy}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td *ngIf="inquirydoc && inquirydoc.InquiryReceivedCopy ==''">
                    <img src="{{dft_icn}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td> Inquiry Received Copy </td>
                <td *ngIf="inquirydoc && inquirydoc.InquiryReceivedCopy==''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-info btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Upload"
                            (click)="openModal(upload,'Inquiry Received Copy');closeModalFileUplaodFalse()"><span
                                class="mdi mdi-cloud-upload mdi-18px"></span></a>
                    </div>
                </td>
                <td *ngIf="inquirydoc && inquirydoc.InquiryReceivedCopy!=''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'InquiryReceivedCopy',downloadurl+inquirydata.InquiryReceivedCopy);closeModalFileUplaodFalse()"><span
                                class="mdi mdi-download mdi-18px"></span></a>

                        <a href="javascript:void(0);"
                            class="btn bg-light-warning btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Delete"
                            (click)="deleteOpenModal(deleteConfirm,'InquiryReceivedCopy',inquirydoc)"><span
                                class="mdi mdi-delete"></span></a>
                    </div>
                </td>
            </tr>
            <tr>
                <td *ngIf="inquirydoc && inquirydoc.QuotationSentCopy!=''">
                    <img src="{{url+inquirydoc.QuotationSentCopy}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td *ngIf="inquirydoc && inquirydoc.QuotationSentCopy ==''">
                    <img src="{{dft_icn}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td>Quotation Sent Copy</td>
                <td *ngIf="inquirydoc && inquirydoc.QuotationSentCopy ==''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-info btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Upload"
                            (click)="openModal(upload,'Quotation Sent Copy');closeModalFileUplaodFalse()"><span
                                class="mdi mdi-cloud-upload mdi-18px"></span></a>
                    </div>
                </td>
                <td *ngIf="inquirydoc && inquirydoc.QuotationSentCopy!=''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'QuotationSentCopy',downloadurl+inquirydata.QuotationSentCopy);closeModalFileUplaodFalse()"><span
                                class="mdi mdi-download mdi-18px"></span></a>

                        <a href="javascript:void(0);"
                            class="btn bg-light-warning btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Delete"
                            (click)="deleteOpenModal(deleteConfirm,'QuotationSentCopy',inquirydoc)"><span
                                class="mdi mdi-delete"></span></a>
                    </div>
                </td>
            </tr>
            <tr>
                <td *ngIf="inquirydoc && inquirydoc.ProductImage!=''">
                    <img src="{{url+inquirydoc.ProductImage}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td *ngIf="inquirydoc && inquirydoc.ProductImage ==''">
                    <img src="{{dft_icn}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td>Technical Data Sheets with Product Image</td>
                <td *ngIf="inquirydoc && inquirydoc.ProductImage ==''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-info btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Upload"
                            (click)="openModal(upload,'Technical Data Sheets with Product Image');closeModalFileUplaodFalse()"><span
                                class="mdi mdi-cloud-upload mdi-18px"></span></a>
                    </div>
                </td>
                <td *ngIf="inquirydoc && inquirydoc.ProductImage!=''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'ProductImage',downloadurl+inquirydata.ProductImage);closeModalFileUplaodFalse()"><span
                                class="mdi mdi-download mdi-18px"></span></a>

                        <a href="javascript:void(0);"
                            class="btn bg-light-warning btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Delete"
                            (click)="deleteOpenModal(deleteConfirm,'ProductImage',inquirydoc)"><span
                                class="mdi mdi-delete"></span></a>
                    </div>
                </td>
            </tr>
            <tr>
                <td *ngIf="inquirydoc && inquirydoc.FactoryBackupDocuments!=''">
                    <img src="{{url+inquirydoc.FactoryBackupDocuments}}" alt=""
                        class="img-thumbnail user-attachment-img">
                </td>
                <td *ngIf="inquirydoc && inquirydoc.FactoryBackupDocuments ==''">
                    <img src="{{dft_icn}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td>Factory Backup Documents</td>
                <td *ngIf="inquirydoc && inquirydoc.FactoryBackupDocuments ==''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-info btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Upload"
                            (click)="openModal(upload,'Factory Backup Documents');closeModalFileUplaodFalse()"><span
                                class="mdi mdi-cloud-upload mdi-18px"></span></a>
                    </div>
                </td>
                <td *ngIf="inquirydoc && inquirydoc.FactoryBackupDocuments!=''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'FactoryBackupDocuments',downloadurl+inquirydata.FactoryBackupDocuments);closeModalFileUplaodFalse()"><span
                                class="mdi mdi-download mdi-18px"></span></a>

                        <a href="javascript:void(0);"
                            class="btn bg-light-warning btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Delete"
                            (click)="deleteOpenModal(deleteConfirm,'FactoryBackupDocuments',inquirydoc)"><span
                                class="mdi mdi-delete"></span></a>
                    </div>
                </td>
            </tr>
            <tr>
                <td *ngIf="inquirydoc && inquirydoc.CostingSheet!=''">
                    <img src="{{url+inquirydoc.CostingSheet}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td *ngIf="inquirydoc && inquirydoc.CostingSheet ==''">
                    <img src="{{dft_icn}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td>Costing Sheet</td>
                <td *ngIf="inquirydoc && inquirydoc.CostingSheet ==''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-info btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Upload"
                            (click)="openModal(upload,'Costing Sheet');closeModalFileUplaodFalse()"><span
                                class="mdi mdi-cloud-upload mdi-18px"></span></a>
                    </div>
                </td>
                <td *ngIf="inquirydoc && inquirydoc.CostingSheet!=''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'CostingSheet',downloadurl+inquirydata.CostingSheet);closeModalFileUplaodFalse()"><span
                                class="mdi mdi-download mdi-18px"></span></a>

                        <a href="javascript:void(0);"
                            class="btn bg-light-warning btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Delete"
                            (click)="deleteOpenModal(deleteConfirm,'CostingSheet',inquirydoc)"><span
                                class="mdi mdi-delete"></span></a>
                    </div>
                </td>
            </tr>

            <tr>
                <td *ngIf="inquirydoc && inquirydoc.Other1!=''">
                    <img src="{{url+inquirydoc.Other1}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td *ngIf="inquirydoc && inquirydoc.Other1 ==''">
                    <img src="{{dft_icn}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td>Other 1</td>
                <td *ngIf="inquirydoc && inquirydoc.Other1 ==''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-info btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Upload"
                            (click)="openModal(upload,'Other 1');closeModalFileUplaodFalse()"><span
                                class="mdi mdi-cloud-upload mdi-18px"></span></a>
                    </div>
                </td>
                <td *ngIf="inquirydoc && inquirydoc.Other1!=''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'Other1',downloadurl+inquirydata.Other1);closeModalFileUplaodFalse()"><span
                                class="mdi mdi-download mdi-18px"></span></a>

                        <a href="javascript:void(0);"
                            class="btn bg-light-warning btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Delete"
                            (click)="deleteOpenModal(deleteConfirm,'Other1',inquirydoc)"><span
                                class="mdi mdi-delete"></span></a>
                    </div>
                </td>
            </tr>
            <tr>
                <td *ngIf="inquirydoc && inquirydoc.Other2!=''">
                    <img src="{{url+inquirydoc.Other2}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td *ngIf="inquirydoc && inquirydoc.Other2 ==''">
                    <img src="{{dft_icn}}" alt="" class="img-thumbnail user-attachment-img">
                </td>
                <td>Other 2</td>
                <td *ngIf="inquirydoc && inquirydoc.Other2 ==''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-info btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Upload"
                            (click)="openModal(upload,'Other 2');closeModalFileUplaodFalse()">
                            <span class="mdi mdi-cloud-upload mdi-18px">
                            </span>
                        </a>
                    </div>
                </td>
                <td *ngIf="inquirydoc && inquirydoc.Other2!=''">
                    <div class="d-flex">
                        <a href="javascript:void(0);"
                            class="btn bg-light-primary btn btn-circle align-items-center d-flex justify-content-center mr-1"
                            placement="bottom" ngbTooltip="Download"
                            (click)="downloadModal(downloadConfirm,'Other2',downloadurl+inquirydata.Other2);closeModalFileUplaodFalse()"><span
                                class="mdi mdi-download mdi-18px"></span></a>

                        <a href="javascript:void(0);"
                            class="btn bg-light-warning btn btn-circle align-items-center d-flex justify-content-center"
                            placement="bottom" ngbTooltip="Delete"
                            (click)="deleteOpenModal(deleteConfirm,'Other2',inquirydoc)"><span
                                class="mdi mdi-delete"></span></a>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<ng-template #upload>
    <div *ngIf="mediaUploadDisplay">
        <div class="modal-header modal-header-new">
            <h4><strong>Inquiry Document</strong></h4>
        </div>
        <div class="modal-body modal-body-new" appDrag (files)="filesDropped($event)">
            <div class="media">
                <div class="w-100">
                    <div class="form-group" style="background-color:#3f97bd; color: #fff;">
                        <div class="text-comment">
                        </div>
                        <a href="javascript:void(0)" class="image-upload d-flex bg-light-new p-2 align-items-center">
                            <label for="file-input" placement="bottom" class="d-block mb-0 w-100 text-center">
                                <h5 class="mb-0 font-bold text-white text-center" style="color:white;">Upload Media
                                    Files</h5>
                            </label>
                            <input id="file-input" (click)="fileInput.value = null" #fileInput type="file"
                                class="d-none"
                                accept="image/png,image/jpeg,image/webp,image/gif,image/aac,.doc,.docx,.pdf,.zip,.rar,.txt,.ppt,.pptx,.csv,.xls,.xlsx"
                                multiple (change)="fileChangeEvent($event);" value="" [disabled]="btnLoader" />
                        </a>
                    </div>

                    <div class="d-flex pt-2" style="overflow-x: auto;">
                        <div *ngFor="let images of imgURL; let i = index" [attr.data-index]="i">
                            <div *ngIf="imgURL" class='position-relative' style="height: 150px;">
                                <div>
                                    <a href="javascript:void(0);" (click)="RemoveImage(images, i)"
                                        class='position-absolute close_img-new my-element'><span
                                            class='mdi mdi-close text-dark'></span></a>
                                    <img *ngIf="images.type == 'image'" alt="" class='mx-2 mb-1 border obj-fit'
                                        src='{{images.url}}'>
                                    <video *ngIf="images.type == 'video'" [muted]="true"
                                        class='mx-2 mb-1 border obj-fit' [src]='images.url'>
                                        <track label="English" kind="captions" srclang="en" src="" default>
                                    </video>
                                </div>
                                <div *ngIf="images.name" class="text-center" ngbTooltip="{{images.name}}"
                                    placement="auto">
                                    <p class="text-dark font-weight-normal previewTestLimit">{{ (images.name.length>10)
                                        ? (images.name | slice:0:10)+'...':(images.name ) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="file_upload_loader" class='text-center'>
                        <div class='spinner-border text-info'><span class='sr-only'></span></div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center border-top border-light pt-2">
                        <div class="send-btn mt-3">
                            <button *ngIf="((fileUploadCount > 0) && !file_upload_loader) && btnLoader==false"
                                class="btn btn-info  btn-sm ml-2" (click)="addMediaPost(mediaPostArr,type);"
                                placement="top" ngbTooltip="Upload">
                                <span class="mdi mdi-send"></span>
                                Upload
                            </button>
                            <button *ngIf="btnLoader==true" class="btn btn-info  btn-sm ml-2"><span
                                    class="spinner-grow spinner-grow-sm"></span> Uploading...</button>

                            <span> <button type="button" *ngIf="btnLoader==false" class="btn btn-secondary btn-sm ml-2"
                                    placement="top" ngbTooltip="Close"
                                    (click)="closeModalFileUplaodFalse();modalRef.hide();">Close</button></span>
                            <span *ngIf="mediaPostArr.mediaPostText?.length >= 2000" class="text-danger ml-3 fs-12">
                                You cannot enter more than 2000 characters.</span>
                            <!-- Adding the message for post file size is greater than 20 MB -->
                            <span *ngIf="postMediaGreaterThanCheckError && mediaPostArr.mediaPostText?.length < 2000"
                                class="text-danger ml-3 fs-12"><strong>{{postMediaGreaterThanCheckError}}</strong></span>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- End Post Media with upload Pals Section (a) -->
        <!-- Post Media with upload Open Forum Section (a) -->
        <div *ngIf="section_type && section_type==2" class="modal-body" appDrag (files)="filesDropped($event)">
            <div class="media">
                <div class="w-100">
                    <div class="form-group">
                        <div class="text-comment">
                            <textarea name="mediaPostText" (ngModelChange)="this.mediaUrlLinkString.next($event)"
                                (paste)="handlePaste($event)" maxlength="2000" [(ngModel)]="mediaPostArr.mediaPostText"
                                #mediaPostText="ngModel" rows="3" class="form-control"
                                placeholder="{{openforum_post_placeholder}}"></textarea>
                        </div>
                        <a href="javascript:void(0)" class="image-upload d-flex bg-light p-2 align-items-center">
                            <label for="file-input" placement="bottom" class="d-block mb-0 w-100">
                                <h5 class="mb-0 font-bold text-dark text-center">Upload Media Files</h5>
                            </label>
                            <input id="file-input" (click)="fileInput.value = null" #fileInput type="file"
                                accept="image/png,image/jpeg,image/webp,image/gif,image/aac,.doc,.docx,.pdf,.zip,.rar,.txt,.ppt,.pptx,.csv,.xls,xlsx"
                                multiple (change)="fileChangeEvent($event)" value="" />
                        </a>
                    </div>
                    <div class="d-flex" style="overflow-x: auto;">
                        <div *ngFor="let images of imgURL; let i = index" [attr.data-index]="i">
                            <div *ngIf="imgURL" class='position-relative'>
                                <div>
                                    <a href="javascript:void(0);" (click)="RemoveImage(images, i)"
                                        class='position-absolute close_img my-element'><span
                                            class='mdi mdi-close text-white'></span></a>
                                    <img *ngIf="images.type == 'image'" alt="" class='mx-2 mb-1 border obj-fit'
                                        src='{{images.url}}'>
                                    <video *ngIf="images.type == 'video'" [muted]="true"
                                        class='mx-2 mb-1 border obj-fit' [src]='images.url'>
                                        <track label="English" kind="captions" srclang="en"
                                            src="resources/myvideo-en.vtt" default>
                                    </video>
                                </div>
                                <div *ngIf="images.name" class="text-center" ngbTooltip="{{images.name}}"
                                    placement="auto">
                                    <p class="text-dark font-weight-normal previewTestLimit">{{images.name}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="text-center" *ngIf="file_upload_loader">
                        <div class="spinner-border text-info" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center border-top border-light pt-2">
                        <div class="send-btn mt-3">
                            <button
                                *ngIf="(fileUploadCount > 0 || (mediaPostArr.mediaPostText?.length > 0 && mediaPostArr.mediaPostText?.length < 2001)) && !file_upload_loader"
                                (click)="openModalPrivacy(postPrivacyMediaConf);" class="btn btn-sm btn-info"
                                placement="top" ngbTooltip="Send" [disabled]="clicked">
                                <img src="{{platform_icon.shout_icon}}" class="img-fluid" alt="..." width="20">
                                Shout
                            </button>
                            <span
                                *ngIf="(mediaPostArr.mediaPostText?.length > 2000 || (fileUploadCount == 0 && mediaPostArr.mediaPostText?.length == 0) || file_upload_loader)">
                                <a href="javascript:void(0);" class="btn btn-sm btn-light" placement="top"
                                    ngbTooltip="Send">
                                    <img src="{{platform_icon.shout_icon}}" class="img-fluid" alt="..." width="20">
                                    Shout
                                </a>
                            </span>
                            <span> <button type="button" class="btn btn-sm btn-post-cancel ml-2" placement="top"
                                    ngbTooltip="Close"
                                    (click)="closeModalFileUplaodFalse();modalRef.hide();">Close</button></span>
                            <span *ngIf="mediaPostArr.mediaPostText?.length >= 2000" class="text-danger ml-3 fs-12">
                                You cannot enter more than 2000 characters.</span>
                            <!-- Adding the massege for post file size is greater than 20 MB -->
                            <span *ngIf="postMediaGreaterThanCheckError && mediaPostArr.mediaPostText?.length < 2000"
                                class="text-danger ml-3 fs-12">{{postMediaGreaterThanCheckError}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="allowDragover">
            <div class="container h-100">
                <div class="row h-100 justify-content-center align-items-center">
                    <div class="center text-center text-dark">Drop your file Here!</div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Post Media with upload Open Forum Section (a)-->
</ng-template>

<ng-template #deleteConfirm>
    <div class="modal-body text-center">
        <p>Do you want to delete {{filename}}?</p>
        <button type="button" class="btn btn-info btn-sm" (click)="deletefileinfo(); modalRef.hide();"
            [disabled]="delNameDel">Delete</button>
        <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
    </div>
</ng-template>

<ng-template #downloadConfirm>
    <div class="modal-body text-center">
        <p>Do you want to Download {{filename}} ?</p>
        <button type="button" class="btn btn-info btn-sm" (click)="download(); modalRef.hide();"
            [disabled]="delNameDel">Download</button>
        <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
    </div>
</ng-template>